import { AfterViewInit, Directive, ElementRef, HostListener, Inject, Input, Renderer2 } from '@angular/core';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';

@Directive({
    selector: '[fiEditorPageContentCenterRoot]',
    standalone: false,
})
export class FiEditorPageContentCenterRootDirective {
    constructor(public readonly elementRef: ElementRef) {}
}

@Directive({
    selector: '[fiEditorPageContentCenter]',
    standalone: false,
})
export class FiEditorPageContentCenterDirective implements AfterViewInit {
    @Input() fiEditorPageContentCenter: HTMLElement;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private detectDevices: DetectDevicesService,
        @Inject(FiEditorPageContentCenterRootDirective) private editorPageContentCenterRoot,
    ) {
        if (this.fiEditorPageContentCenter) renderer.setStyle(this.elementRef.nativeElement, 'position', 'absolute');
    }

    ngAfterViewInit(): void {
        this.centerContent();
    }

    @HostListener('window:resize', ['$event.target'])
    centerContent() {
        if (!this.fiEditorPageContentCenter) return;

        if (!this.detectDevices.isMobilePhone()) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'position', 'absolute');

            const rect = this.fiEditorPageContentCenter.getBoundingClientRect(),
                parentRect = this.editorPageContentCenterRoot.elementRef.nativeElement.getBoundingClientRect(),
                elementRect = this.elementRef.nativeElement.getBoundingClientRect();

            const left = rect.left - parentRect.left + rect.width / 2 - elementRect.width / 2;

            this.renderer.setStyle(this.elementRef.nativeElement, 'left', Math.floor(left) + 'px');
        } else {
            this.renderer.setStyle(this.elementRef.nativeElement, 'position', 'unset');
            this.renderer.setStyle(this.elementRef.nativeElement, 'left', 'unset');
        }
    }
}
